import { siteConfig } from "@/config/siteConfig";

const statusKeys = Object.keys(siteConfig.coverageStatuses);

const buildStatusList = (lang) =>
  statusKeys.map((key) => ({
    value: key,
    label: siteConfig.coverageStatuses[key][lang],
    color: siteConfig.coverageStatuses[key].color,
  }));

const getCoverageStatusMeta = (status, lang = "ar") => {
  const statusMeta = siteConfig.coverageStatuses[status] || siteConfig.coverageStatuses.not_served;
  return {
    value: status,
    label: statusMeta[lang],
    color: statusMeta.color,
  };
};

const formatCoverageWhatsappMessage = ({ locationName, statusLabel, lang = "ar" }) => {
  const text =
    lang === "ar"
      ? `مرحبًا TWIN TC، أريد الاستفسار عن توفر الخدمة في منطقة: ${locationName}، الحالة: ${statusLabel}`
      : `Hello TWIN TC, I would like to inquire about service availability in: ${locationName}, status: ${statusLabel}`;
  return encodeURIComponent(text);
};

export const coverageStatusListAR = buildStatusList("ar");
export const coverageStatusListEN = buildStatusList("en");

export const coverageUtils = {
  statusKeys,
  getCoverageStatusMeta,
  formatCoverageWhatsappMessage,
};
